import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { Toaster } from '@/components/sooner';
// import { TanStackRouterDevtools } from '@tanstack/router-devtools'
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryClient } from '@tanstack/react-query';
import NotFoundError from '@/pages/errors/not-found-error';
import GeneralError from '@/pages/errors/general-error';
import useNetworkStatus from '@/hooks/useNetworkStatus';
import OfflineDialog from '@/pages/home/components/OfflineDialog';

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: () => {
    const { isOnline } = useNetworkStatus();
    return (
      <>
        {!isOnline && <OfflineDialog />}
        {/* <NavigationProgress /> */}
        <Outlet />
        <Toaster />
        {/* {import.meta.env.MODE === 'development' && (
          <>
            <ReactQueryDevtools buttonPosition='bottom-left' />
            <TanStackRouterDevtools position='bottom-right' />
          </>
        )} */}
      </>
    );
  },
  notFoundComponent: NotFoundError,
  errorComponent: GeneralError,
});
